import { render, staticRenderFns } from "./Variation.vue?vue&type=template&id=353d21d2&"
import script from "./Variation.vue?vue&type=script&lang=js&"
export * from "./Variation.vue?vue&type=script&lang=js&"
import style0 from "./Variation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports